import React, { useState, useEffect,useRef, useMemo } from 'react';
import {Main,Axios,Loading,uuidv4,usePaginacion,Paginacion} from '../Helpers/importacionesComunes'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf,faWindowClose,faFileExcel,faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import {useContextoGlobal} from '../Context/contextoGlobal';
import {formatearComparacion,formatoMoneda,hacerfocoEnPrimerInput,seleccionarTextoInput} from '../Helpers/utilidades-globales';
import {transformarIso8601,obtenerFechaDiamenosN,obtenerFechaUltimoDiaMes} from '../Helpers/fechas';
import {imprimir as imprimirEcronologicos} from '../impresiones/ecronologicos';
import ImpresionPDF from '../componentes/ImpresionPDF';
import { Button, Card, Checkbox, Input, Option, Select, Spinner, Typography, Switch } from '@material-tailwind/react';
import { imprimir as imprimirAportantes } from '../impresiones/aportantes';
import Swal from 'sweetalert2';
import ParametrosReportesTiempo from '../componentes/ParametrosReportesTiempo';
import { SeleccionadorX } from '../componentes/SeleccionadorX';
import {listaTiposCriteriosIngresosIntegrales as tiposCriterios} from '../Listas/tiposCriteriosReportes';
import ExportToExcelAportantes from '../componentes/exportToExcelAportantes';
import { ListadoCelular } from '../componentes/ListadoCelular'
import { PresentationChartBarIcon } from "@heroicons/react/24/outline";
import { useField } from 'formik';
import MuiSelect, { SelectChangeEvent } from '@mui/material/Select';
import { Chip, MenuItem, OutlinedInput,ListItemText } from '@mui/material';

const OPCIONES_COLUMNAS_OCULTAR = [
    { key:'promedio_aporte', label:'Promedio' },
];

const anchoPaginacion = 50;
const distr = ['tipo-r-rd', 'tipo-r-fd']
const res = ['tipo-r-geo']
const reportes = [{id:'agrupa-ministros',nombre:'Agrupado por Ministros'},{id:'agrupa-iglesias',nombre:'Agrupado por Iglesias'},{id:'agrupa-meses',nombre:'Agrupado por Meses diezmados'}]
const estadosBalance = [{id_estado_balance:1,nombre:'Presentado'},{id_estado_balance:2,nombre:'No presentado'}]
export default function ReporteObrerosAportes(){
    const [cargandoRegistros,setCargandoRegistros] = useState(false);
    const [huboError,setHuboError] = useState(false);
    const [datos,setDatos] = useState([]);
    const [registrosAmostrar,setRegistrosAmostrar] = useState([]);
    const [textoBusqueda,setTextoBusqueda] = useState('');
    const {usuario} = useContextoGlobal();
    const [contadorConsulta,setContadorConsulta]=useState(0);
    const [mostrarDist, setMostrarDist] = useState(false);
    const [parametros,setParametros]=useState({criterio:'periodo',
                                                id_region:null,
                                                id_distrito:null,
                                                id_rango:null,
                                                id_tipo_iglesia:null,
                                                id_balance_año_fiscal:null,
                                                cant_meses_desde:null,
                                                cant_meses_hasta: null,
                                                promedio_desde:null,
                                                promedio_hasta: null, 
                                                total_desde:null,
                                                total_hasta: null,      
                                                ministrosVinculados:false,  
                                                //hiddenCols: [],
                                                id_estado_balance:null,                                                                                        
                                                fechaDesde:new Date(obtenerFechaDiamenosN(365,'MM/DD/YYYY').diamenosn),
                                                fechaHasta:new Date(),
                                                id_año_fiscal:null,
                                                mesAño:new Date(),
                                                año:new Date()})
    const [regiones,setRegiones] = useState([]);
    const [rangos,setRangos] = useState([]);
    const [tiposIglesias,setTiposIglesias] = useState([]);
    const [periodosFiscales,setPeriodosFiscales] = useState([]);
    const [añosBalances,setAñosBalances] = useState([]);
    const [distritosList, setDistritosList] = useState([])
    const [distritosFiltered, setDistritosFiltered] = useState([])
    const [reporteEnEjecucion,setReporteEnEjecucion] = useState(false)
    const [hideFormvalues,setHideFormvalues] = useState({})
    const [resultado, setResultado] = useState([])
    const [csvFileId, setCsvFileId] = useState(null)
    const [tipoReporte,setTipoReporte] = useState(reportes[0].id);
    const [idResetBusqueda,setIdResetBusqueda] = useState(null) // lo uso para avisar al componente Parametros que si también debe limpiar sus parámetros internos params.checks
    //registerLocale('es', es)

    const [columnas,setColumnas]=useState([
    { campo: 'ministro', titulo: 'Ministro',incluir:true},
    { campo: 'nro_documento', titulo: 'DNI',incluir:false},
    { campo: 'email', titulo: 'E-mail',incluir:false},
    { campo: 'celular', titulo: 'Celular',incluir:false},
    { campo: 'telefono', titulo: 'Teléfono',incluir:false},
    { campo: 'rango_ministro', titulo: 'Rango',incluir:true },
    { campo: 'iglesia', titulo: 'Iglesia',incluir:true },
    { campo: 'region_iglesia', titulo: 'Región',incluir:true },
    { campo: 'distrito_iglesia', titulo: 'Distrito',incluir:false },
    { campo: 'tiene_balance', titulo: 'Balance',incluir:true },
    { campo: 'cant_meses_diezmados', titulo: 'Meses diezmados',incluir:true },
    { campo: 'fechae_balance', titulo: 'Balance Fecha entrega',incluir:true,obligatorio:true,secundario:true },
    {campo: 'meses_lista', titulo: 'Lista meses',incluir:true },
    { campo: 'promedio_aporte', titulo: 'Promedio mensual',incluir:false },
    { campo: 'total_aportado', titulo: 'Aporte',incluir:false },
  ])

    const subtitulo = useRef('');

    useEffect(()=>{
        buscarTablasGenerales()
        .then(()=>{
         console.log('tandas')
            //setParametros({...parametros,id_tanda:tandas[0].id_tanda})
        })
    },[])

    useEffect(()=>{
        if(!parametros.destino){
            setParametros({...parametros,nombre_destino:'',id_obrero:null,id_iglesia:null,id_proveedor:null})
        }else if(parametros.destino=='pastor'){
            setParametros({...parametros,nombre_destino:'',id_iglesia:null,id_proveedor:null})
            hacerfocoEnPrimerInput('destino-n')
        }else if(parametros.destino=='proveedor'){
            setParametros({...parametros,nombre_destino:'',id_iglesia:null,id_obrero:null})
            hacerfocoEnPrimerInput('destino-n')
        }else{
            setParametros({...parametros,nombre_destino:'',id_obrero:null,id_proveedor:null})
            hacerfocoEnPrimerInput('destino-n')
        }
    },[parametros.destino])

    useEffect(()=>{
        if(parametros.id_region){
            const filtered = distritosList.filter(d=>d.id_region==parametros.id_region && d.id_distrito > 0);
            setDistritosFiltered(filtered)
        }else{
            setDistritosFiltered([])
        }
       setParametros({...parametros,id_distrito:null})
    },[parametros.id_region])

    useEffect(()=>{
        subtitulo.current = crearSubtitulosSegunParametros(); 
    },[parametros,cargandoRegistros,tipoReporte]) // agrego a las dependencias la variable cargandoRegistros para que cree el subtitulo inmediatamente aunque no hayan cambiado los parametros porque podría ejecutar el reporte sin modificar la selección o sea con los valores iniciales

    useEffect(()=>{
        if(resultado?.length){
            limpiarResultados()
        }
    },[parametros,tipoReporte])

    useEffect(()=>{
        if(añosBalances?.length){
            setParametros({...parametros, id_balance_año_fiscal:añosBalances[0].id_año_fiscal})
        }
    },[añosBalances])


      const buscarTablasGenerales = async ()=>{
        try{
            setCargandoRegistros(true)
            const vectorResultados = await Promise.all([Axios.get('/api/tablasgenerales/regiones'),
                                                        Axios.get('/api/tablasgenerales/rangos'),
                                                        Axios.get('/api/tablasgenerales/tiposiglesias'),
                                                        Axios.get('/api/tablasgenerales/reportes/perfiscales'),
                                                        Axios.get(`/api/tablasgenerales/distritos/*`),
                                                        Axios.get('/api/tablasgenerales/reportes/balances')])
            setRegiones(vectorResultados[0].data.filter(r=>r.id_region>0))

            const rangosOrdenados = vectorResultados[1].data.filter(r=>r.id_rango>0).sort((a,b)=>a.orden-b.orden)
            setRangos([{id_rango:103,iniciales:'MO*'},...rangosOrdenados]) // Agrego un rango MO* para agrupar todos los rangos que comiencen con MO
            const tiposIglOrdenados = vectorResultados[2].data.filter(t=>t.id_tipo_iglesia>0).sort((a,b)=>a.orden-b.orden)
            setTiposIglesias(tiposIglOrdenados)
            setDistritosList(vectorResultados[4].data)
            setPeriodosFiscales(vectorResultados[3].data.reverse())
            setAñosBalances(vectorResultados[5].data)
            setCargandoRegistros(false)
            setParametros({...parametros,id_rango:103,id_balance_año_fiscal:4,id_estado_balance:1})
        }catch(err){
            setCargandoRegistros(false)
            setHuboError(true)
            console.log('Error al buscar los datos generales',err)  
        }
    }

    const triggerReport = async ()=>{
        try{
            const url = '/api/reportes/mesesdiezmados';
            let dataSubmit = {
                mes: parametros.criterio === 'mesaño' ? parametros.mesAño.getMonth() + 1 : null,
                año: parametros.criterio === 'año' ? parametros.año.getFullYear() : parametros.criterio === 'mesaño' ? parametros.mesAño.getFullYear() : null,
                id_año_fiscal: parametros.criterio==='añofiscal' ? parametros.id_año_fiscal: null,
                f_desde: parametros.criterio === 'periodo' ? convertirMesAñoAfechaDesde(parametros.fechaDesde) : parametros.criterio === 'fecha' ? convertirMesAñoAfechaCompleta(parametros.fechaDesde) :  null,
                f_hasta: parametros.criterio === 'periodo' ? convertirMesAñoAfechaHasta(parametros.fechaHasta) : parametros.criterio === 'fecha' ? convertirMesAñoAfechaCompleta(parametros.fechaHasta) : null,
                id_region: parametros.id_region,
                id_distrito:parametros.id_region ? parametros.id_distrito : null,
                id_tipo_iglesia:parametros.id_tipo_iglesia,
                id_balance_año_fiscal:parametros.id_balance_año_fiscal,
                total_desde:parametros.total_desde,
                total_hasta:parametros.total_hasta,
                promedio_desde:parametros.promedio_desde,
                promedio_hasta:parametros.promedio_hasta,
                cant_meses_desde:parametros.cant_meses_desde,
                cant_meses_hasta:parametros.cant_meses_hasta,
                ministrosVinculados:parametros.ministrosVinculados,
                id_estado_balance:parametros.id_estado_balance,
                id_rango:parametros.id_rango
            };

            setReporteEnEjecucion(true)
            const {data} = await Axios.post(url, dataSubmit)
            const dataReporte = data.datos;

            if (dataReporte.length > 0) {

                setResultado(dataReporte)
                setCsvFileId(data?.fileId)
                setReporteEnEjecucion(false)
            } else {
                setResultado([])
                setCsvFileId(null)
                Swal.fire({
                    icon: 'warning',
                    title: `<p>No se encontraron registros</p>`,
                    showCancelButton: true,
                });
                setReporteEnEjecucion(false)
            }

        } catch(err){
            console.log(err);
            console.log('Error al buscar los datos generales')  
            Swal.fire({
                icon: 'error',
                title: `<p>Ha ocurrido un error durante la petición</p>`,
                showCancelButton: true,
            });
            setReporteEnEjecucion(false)
        }
    }

    const crearSubtitulosSegunParametros = () => {
        let descripcion = '';

        switch(parametros.criterio){
            case tiposCriterios.añofiscal:
                descripcion = `${descripcion} Año fiscal: ${
                    periodosFiscales
                        .filter(item => item.id_año_fiscal == parametros.id_año_fiscal)
                        .map(item => item.nombre)
                }`;
                break;

            case tiposCriterios.mesaño:
                descripcion = `${descripcion} Mes y año: ${obtenerValueDeID('select-mesaño')}`;
                break;

            case tiposCriterios.año:
                descripcion = `${descripcion} Año: ${obtenerValueDeID('select-año')}`;
                break;

            case tiposCriterios.periodo:
                descripcion = `${descripcion} Período: ${obtenerValueDeID('select-periodo-fdesde')} --> ${obtenerValueDeID('select-periodo-fhasta')}`;
                break;

            case tiposCriterios.fecha:
                descripcion = `${descripcion} Fecha: ${obtenerValueDeID('select-fecha')}`;
                break;
        }

        if (parametros.id_rango){
            descripcion += ` Rango: ${getSelectedText('select-rango')}`;
        }

        if (parametros.id_tipo_iglesia){
            descripcion += ` Tipo Igl: ${getSelectedText('select-tipo-iglesia')}`;
        }

        if (parametros.id_region){
            descripcion += ` Región: ${getSelectedText('select-region')}`;
        }

        if (parametros.id_distrito){
            descripcion += ` Distrito: ${getSelectedText('select-distrito')}`;
        }

        if (parametros.id_balance_año_fiscal){
            descripcion += ` Balance: ${getSelectedText('select-balance')}`;
        }

        return descripcion;
    };


    const getSelectedText = (id) => {
        const el = document.getElementById(id);
        return el?.options?.[el.selectedIndex]?.text ?? '';
    };

      const handleChangeColumnas = (event) => {
        const { value } = event.target;

        const nuevasColumnas = columnas.map(col => ({
            ...col,
            incluir: value.includes(col.campo)
        }));

        setColumnas(nuevasColumnas);
    };

    const limpiarBusqueda = async () => {
        setParametros({criterio:'periodo',id_region:null,id_distrito:null,
                                                id_rango:null,
                                                id_tipo_iglesia:null,
                                                id_balance_año_fiscal:añosBalances[0].id_año_fiscal,
                                                cant_meses_desde:null,
                                                cant_meses_hasta: null,
                                                promedio_desde:null,
                                                promedio_hasta: null, 
                                                ministrosVinculados:false,
                                                //hiddenCols: [],
                                                id_estado_balance:null,
                                                total_desde:null,
                                                total_hasta: null,                                                                                                
                                                fechaDesde:new Date(obtenerFechaDiamenosN(365,'MM/DD/YYYY').diamenosn),
                                                fechaHasta:new Date(),
                                                id_año_fiscal:null,
                                                mesAño:new Date(),
                                                año:new Date()});
       setIdResetBusqueda(uuidv4())                                                
       limpiarResultados()
    }

    const limpiarResultados = ()=>{
        setResultado([])
        setCsvFileId(null)
        setTipoReporte('agrupa-meses')
    }
       
    const imprimirPDF = ()=>{
        const nombrePDF = 'Reporte de aportantes';
        const tituloPDF = subtitulo.current;
        console.log('envio esto',resultado)
        imprimirAportantes(resultado, nombrePDF, tituloPDF,'portrait',parametros,tipoReporte);
    }

    if (huboError){
        return <Main center>
            <div className='flex flex-col justify-center items-center h-[calc(100vh-10rem)]'>
                <p>Se produjo un error al cargar los datos para esta vista</p>
            </div>
        </Main>
    }

    if (cargandoRegistros){
        return <Main center alinear>
                    <div className='flex flex-col justify-center items-center h-[calc(100vh-10rem)]'>
                        <Spinner className="h-12 w-12" />
                        <span className="cargando font-semibold text-[15px]">Cargando registros...</span>
                    </div>
                </Main>
    };

    return (  
    <Main center>  
        <div className={'mr-6 ml-6'} id="reporte-aportantes">
            <div className="flex f-col text-large justify-center items-center mb-4">
                <Typography variant="h4">
                    Aportantes 
                </Typography>
            </div>
        <Card className="mt-4 w-full p-10 mb-10">            
            <Parametros parametros = {parametros} 
                        setParametros={setParametros} 
                        regiones={regiones}
                        rangos={rangos}
                        reportes = {reportes}
                        tiposIglesias={tiposIglesias}
                        periodosFiscales={periodosFiscales}
                        estadosBalance={estadosBalance}
                        añosBalances={añosBalances}
                        distritosFiltered={distritosFiltered}
                        centrado={contadorConsulta==0 ? true : false}
                        reporteEnEjecucion = {reporteEnEjecucion}
                        hideFormvalues = {hideFormvalues}
                        tipoReporte={tipoReporte}
                        resultado={resultado}
                        setTipoReporte={setTipoReporte}
                        ejecutarReporte={triggerReport}
                        handleChangeColumnas={handleChangeColumnas}
                        setColumnas={setColumnas}
                        columnas={columnas}
                        idResetBusqueda = {idResetBusqueda}/>

            <Preview  resultado={resultado} limpiarBusqueda={limpiarBusqueda} imprimirPDF={imprimirPDF} csvFileId={csvFileId} columnas={columnas} setColumnas={setColumnas} />
        </Card>
        </div>
    </Main>
    )
}

const Preview = ({resultado,limpiarBusqueda,imprimirPDF,csvFileId,setColumnas,columnas}) =>{
    const { esCelular} = useContextoGlobal();
    const [hiddenCols,setHiddenCols]=useState([]);
//     const [columnas,setColumnas]=useState([
//     { campo: 'ministro', titulo: 'Ministro',incluir:true},
//     { campo: 'rango_ministro', titulo: 'Rango',incluir:true },
//     { campo: 'iglesia', titulo: 'Iglesia',incluir:true },
//     { campo: 'region_iglesia', titulo: 'Región',incluir:true },
//     { campo: 'distrito_iglesia', titulo: 'Distrito',incluir:true },
//     { campo: 'tiene_balance', titulo: 'Balance',incluir:true },
//     { campo: 'cant_meses_diezmados', titulo: 'Meses diezmados',incluir:true },
//     {campo: 'meses_lista', titulo: 'Lista meses',incluir:true },
//     { campo: 'promedio_aporte', titulo: 'Promedio mensual',incluir:true },
//     { campo: 'total_aportado', titulo: 'Aporte',incluir:true },
//   ])
    const openPreview = () => {
        if(!csvFileId) {alert(`El gráfico no pudo ser generado. No se encontró el fileId`);return}

        const html = `http://137.184.118.171:8001/estadisticas/min/aportes/imagen/${csvFileId}`
        window.open(html,"_blank");
    };

//     const columnas = [
//     { campo: 'ministro', titulo: 'Ministro',incluir:true},
//     { campo: 'rango_ministro', titulo: 'Rango',incluir:true },
//     { campo: 'iglesia', titulo: 'Iglesia',incluir:true },
//     { campo: 'region_iglesia', titulo: 'Región',incluir:true },
//     { campo: 'distrito_iglesia', titulo: 'Distrito',incluir:true },
//     { campo: 'tiene_balance', titulo: 'Balance',incluir:true },
//     { campo: 'cant_meses_diezmados', titulo: 'Meses diezmados',incluir:true },
//     {campo: 'meses_lista', titulo: 'Lista meses',incluir:true },
//     { campo: 'promedio_aporte', titulo: 'Promedio mensual',incluir:true },
//     { campo: 'total_aportado', titulo: 'Aporte',incluir:true },
//   ];

 const handleChangeHiddenCols = (e) => {
        const { value } = e.target;

        setHiddenCols(typeof value === 'string' ? value.split(',') : value)
        // setParametros({
        //   ...parametros,
        //   hiddenCols: typeof value === 'string' ? value.split(',') : value
        // });
    };

    const handleChangeColumnas = (event) => {
        const { value } = event.target;

        const nuevasColumnas = columnas.map(col => ({
            ...col,
            incluir: value.includes(col.campo)
        }));

        setColumnas(nuevasColumnas);
    };


        if(!resultado?.length) return null

        return <div classNamess='w-full flex flex-col justify-center items-center lg:!m-6 xl:!m-6'>
                    <div className="flex flex-col md:flex-row gap-2 xl:!justify-end">
                        <Button variant='text' className='text-red-400 bg-red-100 hover:bg-red-200' onClick={limpiarBusqueda}>Limpiar Busqueda</Button>
                        <Button variant="gradient" className="flex ml-2 justify-center items-center gap-3" onClick={imprimirPDF}>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                strokeWidth={2}
                                                stroke="currentColor"
                                                className="h-4 w-4/"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    d="M12 16.5V9.75m0 0l3 3m-3-3l-3 3M6.75 19.5a4.5 4.5 0 01-1.41-8.775 5.25 5.25 0 0110.233-2.33 3 3 0 013.758 3.848A3.752 3.752 0 0118 19.5H6.75z"
                                                />
                                            </svg>
                                            Exportar PDF
                        </Button>
                        <ExportToExcelAportantes data={resultado} fileName="Reporte de Aportantes"/>
                        {csvFileId && <Button
                            variant="text"
                            className="flex items-center gap-2"
                            onClick={openPreview}
                        >
                            <PresentationChartBarIcon className="h-5 w-5" />
                            Ver gráfico
                        </Button>}
                    </div>
                    <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-normal leading-none hidden lg:flex"
                    >
                        Se han encontrado {resultado.length} registros
                    </Typography>


                                {/* <div className="flex items-center gap-2 w-full">
                                    <div className="w-full">
                                        <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-full">
                                    <Select
                                    multiple
                                    displayEmpty
                                    value={columnas.filter(c => c.incluir).map(c => c.campo)}
                                    onChange={handleChangeColumnas}
                                    input={<OutlinedInput size="small" />}
                                    renderValue={(selected) => {
                                        if (selected.length === 0) return 'Columnas a mostrar';
                                        return (
                                        <div className="flex flex-wrap gap-1">
                                            {selected.map(val => {
                                            const opt = columnas.find(c => c.campo === val);
                                            return <Chip key={val} size="small" label={opt?.titulo || val} />;
                                            })}
                                        </div>
                                        );
                                    }}
                                    sx={{ backgroundColor: '#fff', width: '100%' }}
                                    >
                                    {columnas.map(col => (
                                        <MenuItem
                                            key={col.campo}
                                            value={col.campo}
                                            onClick={() => {
                                                const nuevasColumnas = columnas.map(c =>
                                                c.campo === col.campo ? { ...c, incluir: !c.incluir } : c
                                                );
                                                setColumnas(nuevasColumnas);
                                            }}
                                            >
                                            <Checkbox checked={col.incluir} />
                                            <ListItemText primary={col.titulo} />
                                            </MenuItem>

                                    ))}
                                </Select>
                                        </div>
                                    </div>
                                </div>     */}




                    <div className='mt-8 w-full'>
                        {esCelular ? 
                            <ListadoCelular datos={resultado.map(i=>{
                                return {Ministro:i.ministro,Rango:i.rango_ministro,Región:i.region_iglesia,Distrito:i.distrito_iglesia,Meses:i.cant_meses_diezmados,Aporte:i.total_aportado,Promedio:i.promedio_aporte}
                            })} campoNombre={"Ministro"}/>
                                :
                            <TablaResultados resultado={resultado} columnas={columnas}/>
                        }
                    </div>
                    
        </div>
}

const TablaResultadosold = ({resultado,columnas})=>{
const [orden, setOrden] = useState({ campo: null, direccion: 'asc' });
const columnasVisibles = columnas.filter(col => col.incluir);

  const manejarOrden = (campo) => {
    setOrden((prev) => ({
      campo,
      direccion: prev.campo === campo && prev.direccion === 'asc' ? 'desc' : 'asc',
    }));
  };

const resultadoOrdenado = useMemo(() => {
  const filtrarCamposVisibles = (item) => {
    const nuevo = {};
    columnasVisibles.forEach(campo => {
      nuevo[campo] = item[campo];
    });
    return nuevo;
  };

  if (!orden.campo) {
    return resultado.map(filtrarCamposVisibles);
  }

  const ordenado = [...resultado].sort((a, b) => {
    const valorA = a[orden.campo] ?? '';
    const valorB = b[orden.campo] ?? '';

    if (typeof valorA === 'string') {
      return orden.direccion === 'asc'
        ? valorA.localeCompare(valorB)
        : valorB.localeCompare(valorA);
    }

    return orden.direccion === 'asc' ? valorA - valorB : valorB - valorA;
  });

  return ordenado.map(filtrarCamposVisibles);
}, [resultado, orden, columnas]);

  return (
    <table className="w-full table-auto text-left mt-2" style={{ tableLayout: 'fixed' }}>
      <thead>
        <tr>
          {columnasVisibles.map(({ campo, titulo }) => (
            <th
              key={campo}
              className="border-b border-blue-gray-100 bg-blue-gray-50 p-4 cursor-pointer"
              onClick={() => manejarOrden(campo)}
            >
              <Typography
                variant="small"
                color="blue-gray"
                className="font-normal leading-none opacity-70"
              >
                {titulo}
                {orden.campo === campo ? (orden.direccion === 'asc' ? ' 🔼' : ' 🔽') : ''}
              </Typography>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {resultadoOrdenado.map((item, index) => {
          const isLast = index === resultadoOrdenado.length - 1;
          const classes = isLast ? 'p-4' : 'p-4 border-b border-blue-gray-50';

          return (
            <tr key={index}>
              <td className={classes}>{item.ministro}</td>
              <td className={classes}>{item.rango_ministro}</td>
              <td className={classes}>
                {item.iglesia} {item.dom_linea_2 ?? ''}
              </td>
              <td className={classes}>{item.region_iglesia}</td>
              <td className={classes}>{item.distrito_iglesia}</td>
              <td className={classes}>
                <div className='text-center'>
                    <p>{item.tiene_balance ? 'SI': 'NO'}</p> <p className='text-sm'>{item.fechae_balance}</p>
                </div>
              </td>
              <td className={`${classes} text-center`}>{item.cant_meses_diezmados}</td>
              <td className={`${classes} text-center`}>{item.meses_lista}</td>
              <td className={`${classes} text-right`}>
                {item.promedio_aporte?.toLocaleString('es-ES', {
                  useGrouping: true,
                  minimumFractionDigits: 2,
                })}
              </td>
              <td className={`${classes} text-right`}>
                {item.total_aportado?.toLocaleString('es-ES', {
                  useGrouping: true,
                  minimumFractionDigits: 2,
                })}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}


const TablaResultados = ({ resultado, columnas }) => {
  const [orden, setOrden] = useState({ campo: null, direccion: 'asc' });

  // Filtrar columnas visibles
  const columnasVisibles = columnas.filter(col => col.incluir);

  // Manejar ordenamiento
  const manejarOrden = (campo) => {
    setOrden((prev) => ({
      campo,
      direccion: prev.campo === campo && prev.direccion === 'asc' ? 'desc' : 'asc',
    }));
  };

  // Filtrar campos visibles por cada item
  const resultadoOrdenado = useMemo(() => {
    const filtrarCamposVisibles = (item) => {
      const nuevo = {};
      columnasVisibles.forEach(({ campo }) => {
        nuevo[campo] = item[campo];
      });
      return nuevo;
    };

    if (!orden.campo) {
      return resultado.map(filtrarCamposVisibles);
    }

    const ordenado = [...resultado].sort((a, b) => {
      const valorA = a[orden.campo] ?? '';
      const valorB = b[orden.campo] ?? '';

      if (typeof valorA === 'string') {
        return orden.direccion === 'asc'
          ? valorA.localeCompare(valorB)
          : valorB.localeCompare(valorA);
      }

      return orden.direccion === 'asc' ? valorA - valorB : valorB - valorA;
    });

    return ordenado.map(filtrarCamposVisibles);
  }, [resultado, orden, columnas]);

  return (
    <table className="w-full table-auto text-left mt-2" style={{ tableLayout: 'fixed' }}>
      <thead>
        <tr>
          {columnasVisibles.filter(i=>!i.secundario).map(({ campo, titulo }) => (
            <th
              key={campo}
              className="border-b border-blue-gray-100 bg-blue-gray-50 p-4 cursor-pointer"
              onClick={() => manejarOrden(campo)}
            >
              <Typography
                variant="small"
                color="blue-gray"
                className="font-normal leading-none opacity-70"
              >
                {titulo}
                {orden.campo === campo ? (orden.direccion === 'asc' ? ' 🔼' : ' 🔽') : ''}
              </Typography>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {resultadoOrdenado.map((item, index) => {
          const isLast = index === resultadoOrdenado.length - 1;
          const classes = isLast ? 'p-4' : 'p-4 border-b border-blue-gray-50';

          return (
            <tr key={index}>
              {columnasVisibles.map(({ campo,obligatorio,secundario }) => {
                let contenido = item[campo];

                if(secundario){
                    return null
                }

                // Formateos especiales
                if (campo === 'promedio_aporte' || campo === 'total_aportado') {
                  contenido = contenido?.toLocaleString('es-ES', {
                    useGrouping: true,
                    minimumFractionDigits: 2,
                  });
                }

                if (campo === 'tiene_balance') {
                  contenido = (
                    <div className="text-center">
                      <p>{item.tiene_balance ? 'SI' : 'NO'}</p>
                      <p className="text-sm">{item.fechae_balance}</p>
                    </div>
                  );
                }

                if (campo === 'iglesia') {
                  contenido = `${item.iglesia ?? ''} ${item.dom_linea_2 ?? ''}`;
                }

                return (
                  <td key={campo} className={classes}>
                    {contenido}
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

function Parametros({parametros,
                    setParametros,
                    regiones,
                    rangos,
                    añosBalances,
                    reportes,
                    estadosBalance,
                    tiposIglesias,
                    tipoReporte,
                    setTipoReporte,
                    reporteEnEjecucion,
                    ejecutarReporte,
                    distritosFiltered,
                    resultado,idResetBusqueda,handleChangeColumnas,columnas,setColumnas}){

    const inputBusquedaRef = useRef()
    const nombreCriterio = useRef('Seleccione el año fiscal:')
    const r2 = useRef('null')
    const [paramsCheck,setParamsCheck] = useState({
        promedios:false,
        totales:false,
        meses:false
    })
    const [buscarDestino,setBuscarDestino] = useState(false)
    const [iglesias,setIglesias] = useState([])
    const [versionVieja,setVersionVieja] = useState(false)

    useEffect(()=>{
        if(paramsCheck.totales){
            setParametros({...parametros,total_desde:0,total_hasta:0})
            hacerfocoEnPrimerInput(`totales-desde`)
        }else{
            setParametros({...parametros,total_desde:null,total_hasta:null})
        }
    },[paramsCheck.totales])

    useEffect(()=>{
        if(paramsCheck.promedios){
            setParametros({...parametros,promedio_desde:0,promedio_hasta:0})
            hacerfocoEnPrimerInput(`promedios-desde`)
        }else{
            setParametros({...parametros,promedio_desde:null,promedio_hasta:null})
        }
    },[paramsCheck.promedios])

 useEffect(()=>{
        if(paramsCheck.meses){
            setParametros({...parametros,cant_meses_desde:0,cant_meses_hasta:0})
            hacerfocoEnPrimerInput(`meses-desde`)
        }else{
            setParametros({...parametros,cant_meses_desde:null,cant_meses_hasta:null})
        }
    },[paramsCheck.meses])

    useEffect(()=>{
        setParamsCheck({
            promedios:false,
            totales:false,
            meses:false
        }) 
    },[idResetBusqueda])

    const handleCheckCriterio = (e)=>{
        const nuevoCriterio = e.target.value
        console.log("parametros", parametros);
        reinicializarCriterios(setParametros,parametros,nuevoCriterio)
        cargarNombreCriterio(nuevoCriterio,nombreCriterio)
        hacerfocoEnPrimerInput(`select-${e.target.value}`)
    }

    const handleCheckTipo = (e)=>{
        setParametros({...parametros,tipo : e.target.value,criterio:'periodo'})
    }

    const validarParametros = ()=>{

        if (parametros.criterio=="añofiscal" && !parametros.id_año_fiscal){
            alert('Falta seleccionar un año fiscal')
            return
        }
        if (parametros.criterio=="año" && !parametros.año){
            alert('Falta seleccionar un año')
            return
        }
        if (parametros.criterio=="mesaño" && !parametros.mesAño){
            alert('Falta seleccionar un mes y un año')
            return
        }
        if (parametros.criterio=="periodo" && (!parametros.fechaHasta || !parametros.fechaDesde)){
            alert('Falta seleccionar un mes y un año')
            return
        }
        if (parametros.criterio=="fecha" && !parametros.fecha){
            alert('Falta seleccionar un mes y un año')
            return
        }
        if(paramsCheck.meses){
             if(Number(parametros.cant_meses_desde) > Number(parametros.cant_meses_hasta)){
                alert('El rango de meses diezmados es incorrecto')
                return
            }
        }else{
            setParametros({...parametros,cant_meses_desde:null,cant_meses_hasta:null})
        }


        if(paramsCheck.promedios){
            if(Number(parametros.promedio_desde)==0 && Number(parametros.promedio_hasta)==0){
                alert('Falta seleccionar el rango de promedios')
                return
            }
             if(Number(parametros.promedio_desde) > Number(parametros.promedio_hasta)){
                alert('El rango de promedios es incorrecto')
                return
            }            
        }else{
            setParametros({...parametros,promedio_desde:null,promedio_hasta:null})
        }

        if(paramsCheck.totales){
            if(Number(parametros.total_desde)==0 && Number(parametros.total_hasta)==0){
                alert('Falta seleccionar el rango de aportes')
                return
            }
             if(Number(parametros.total_desde) > Number(parametros.total_hasta)){
                alert('El rango de aportes es incorrecto')
                return
            }                 
        }else{
            setParametros({...parametros, total_desde:null,total_hasta:null})
        }

        ejecutarReporte()

    }

    const columnasSeleccionadas = columnas.filter(c => c.incluir && !c.obligatorio).map(c => c.campo);



    return <div classNamex="mt-4 w-full p-10 mb-10">
                <div className="flex f-col">
                    <ParametrosReportesTiempo parametros = {parametros} handleCheckCriterio = {handleCheckCriterio} setParametros = {setParametros}/>
                        <Card className="w-full px-6 py-3 mb-3 shadow-md">
                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-1">
                                {/* Primera columna */}
                                <div className="flex items-center gap-2 w-full">
                                    <div className="w-[220px]">
                                        <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                            Rango:
                                        </Typography>
                                    </div>
                                    <div className="w-full">
                                        <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                            <SeleccionadorX newversion id='select-rango' vector={rangos} valor={parametros.id_rango} nombre="Todos" onchange={(e)=>setParametros({...parametros,id_rango:ConvertirValor(e.target.value)})} claves={{id:'id_rango',nombre:'iniciales'}}/> 
                                        </div>   
                                    </div>
                                </div>
        
                                <div className="flex items-center gap-2 w-full">
                                    <div className="w-[220px]">
                                        <Typography variant="h6" color="blue-gray" className="mt-1">
                                            Tipo de iglesia:
                                        </Typography>
                                    </div>
                                     <div className="w-full">
                                        <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                            <SeleccionadorX newversion id='select-tipo-iglesia' vector={tiposIglesias} valor={parametros.id_tipo_iglesia} nombre="Todos" onchange={(e)=>setParametros({...parametros,id_tipo_iglesia:ConvertirValor(e.target.value)})} claves={{id:'id_tipo_iglesia',nombre:'nombre'}}/> 
                                        </div>   
                                    </div>
                                </div>
                                <div className="flex items-center gap-2 w-full egreso-new">
                                    <div className="w-[220px]">
                                        <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                            Región:
                                        </Typography>
                                    </div>
                                    <div className="w-full">
                                        <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                            <SeleccionadorX newversion id='select-region' vector={regiones} valor={parametros.id_region} nombre="Todos" onchange={(e)=>setParametros({...parametros,id_region:ConvertirValor(e.target.value)})} claves={{id:'id_region',nombre:'nombre'}}/> 
                                        </div>   
                                    </div>
                                </div>
                                {parametros.id_region && <div className="flex items-center gap-2 w-full egreso-new">
                                    <div className="w-[220px]">
                                        <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                            Distrito: 
                                        </Typography>
                                    </div>
                                    <div className="w-full">
                                        <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                            <SeleccionadorX newversion id='select-distrito' vector={distritosFiltered} valor={parametros?.id_distrito} nombre="Todos" onchange={(e)=>setParametros({...parametros,id_distrito:ConvertirValor(e.target.value)})} claves={{id:'id_distrito_region',nombre:'nombre'}}/> 
                                        </div>   
                                    </div>
                                </div>}                                
                            </div>
                        </Card>

                        <Card className="w-full px-6 py-3 mb-3 shadow-md">
                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-1">
                                {/* Primera columna */}

                                <div className="flex flex-col sm:flex-row items-center gap-2 w-full">
                                    <div className="w-[220px]">
                                        <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                            Meses diezmados
                                        </Typography>
                                        <div className="w-full">
                                            <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                                <Switch
                                                    ripple={false}
                                                    name="sw-mesesdiezmados"
                                                    checked={paramsCheck.meses}
                                                    onChange={(e) => setParamsCheck({ ...paramsCheck, meses: e.target.checked ? true : false })}
                                                />
                                            </div>   
                                        </div>
                                    </div>
                                    <div className={`${paramsCheck.meses ? '' : ''}`}>
                                        <div className="grid grid-cols-1 lg:grid-cols-2 mt-0 lg:ml-1 gap-4 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                             <div className="flex flex-col">
                                                <span className="text-xsmall">Mínimo</span>
                                                <Input
                                                    name="meses-desde"
                                                    id="meses-desde" 
                                                    type="number" 
                                                    value={parametros.cant_meses_desde || 0} 
                                                    onChange={(e) => setParametros({ ...parametros, cant_meses_desde: e.target.value })} 
                                                    ref={inputBusquedaRef} 
                                                    disabled={!paramsCheck.meses}
                                                    placeholder={'0'}
                                                    className="input-ui-data w-full disabled:bg-gray-300 disabled:text-gray-500 disabled:border-gray-400"
                                                    labelProps={{
                                                        className: "before:content-none after:content-none",
                                                    }}
                                                />
                                            </div>
                                             <div className="flex flex-col">
                                                <span className="text-xsmall">Máximo</span>
                                                <Input
                                                    name="meses-hasta"
                                                    id="meses-hasta" 
                                                    type="number" 
                                                    value={parametros.cant_meses_hasta || 0} 
                                                    onChange={(e) => setParametros({ ...parametros, cant_meses_hasta: e.target.value })} 
                                                    ref={inputBusquedaRef} 
                                                    placeholder={'0'}
                                                    disabled={!paramsCheck.meses}
                                                    className="input-ui-data w-full disabled:bg-gray-300 disabled:text-gray-500 disabled:border-gray-400"
                                                    labelProps={{
                                                        className: "before:content-none after:content-none",
                                                    }}
                                                />
                                            </div>
                                        </div>   
                                    </div>
                                </div>

                                <div className="flex flex-col sm:flex-row items-center gap-2 w-full">
                                    <div className="w-[220px]">
                                        <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                            Promedio mensual
                                        </Typography>
                                        <div className="w-full">
                                            <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                                <Switch
                                                    ripple={false}
                                                    name="sw-prom-mensual"
                                                    checked={paramsCheck.promedios}
                                                    onChange={(e) => setParamsCheck({ ...paramsCheck, promedios: e.target.checked ? true : false })}
                                                />
                                            </div>   
                                        </div>
                                    </div>
                                    <div className={`${paramsCheck.promedios ? '' : ''}`}>
                                        <div className="grid grid-cols-1 lg:grid-cols-2 mt-0 lg:ml-1 gap-4 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                            <div className="flex flex-col">
                                                <span className="text-xsmall">Mínimo</span>
                                                <Input
                                                    name="promedios-desde"
                                                    id="promedios-desde" 
                                                    type="number" 
                                                    disabled={!paramsCheck.promedios}
                                                    value={parametros.promedio_desde || 0} 
                                                    onChange={(e) => setParametros({ ...parametros, promedio_desde: e.target.value })} 
                                                    ref={inputBusquedaRef} 
                                                    placeholder={'0'}
                                                    className="input-ui-data w-full disabled:bg-gray-300 disabled:text-gray-500 disabled:border-gray-400"
                                                    labelProps={{
                                                        className: "before:content-none after:content-none",
                                                    }}
                                                />
                                            </div>
                                            <div className="flex flex-col">
                                                <span className="text-xsmall">Máximo</span>
                                                <Input
                                                    name="promedios-hasta"
                                                    id="promedios-hasta" 
                                                    type="number" 
                                                    value={parametros.promedio_hasta || 0} 
                                                    onChange={(e) => setParametros({ ...parametros, promedio_hasta: e.target.value })} 
                                                    ref={inputBusquedaRef} 
                                                    placeholder={'0'}
                                                    disabled={!paramsCheck.promedios}
                                                    className="input-ui-data w-full disabled:bg-gray-300 disabled:text-gray-500 disabled:border-gray-400"
                                                    labelProps={{
                                                        className: "before:content-none after:content-none",
                                                    }}
                                                />
                                             </div>
                                        </div>   
                                    </div>
                                </div>


                                <div className="flex flex-col sm:flex-row items-center gap-2 w-full">
                                    <div className="w-[220px]">
                                        <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                           Aportes
                                        </Typography>
                                        <div className="w-full">
                                            <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                                <Switch
                                                    ripple={false}
                                                    name="sw-aportes"
                                                    checked={paramsCheck.totales}
                                                    onChange={(e) => setParamsCheck({ ...paramsCheck, totales: e.target.checked ? true : false })}
                                                />
                                            </div>   
                                        </div>
                                    </div>
                                    <div className={`${paramsCheck.totales ? '' : ''}`}>
                                        <div className="grid grid-cols-1 lg:grid-cols-2 mt-0 lg:ml-1 gap-4 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                             <div className="flex flex-col"  id="xxx">
                                                <span className="text-xsmall">Mínimo</span>
                                                <Input
                                                    name="totales-desde"
                                                    id="totales-desde" 
                                                    type="number" 
                                                    value={parametros.total_desde || 0} 
                                                    onChange={(e) => setParametros({ ...parametros, total_desde: e.target.value })} 
                                                    ref={inputBusquedaRef} 
                                                    placeholder={'0'}
                                                    disabled={!paramsCheck.totales}
                                                    className="w-full input-ui-data disabled:bg-gray-500 disabled:text-gray-500 disabled:border-gray-400"
                                                    labelProps={{
                                                        className: "before:content-none after:content-none",
                                                    }}
                                                />
                                            </div>
                                             <div className="flex flex-col">
                                                <span className="text-xsmall">Máximo</span>
                                                <Input
                                                    name="totales-hasta"
                                                    id="totales-hasta" 
                                                    type="number" 
                                                    value={parametros.total_hasta || 0} 
                                                    onChange={(e) => setParametros({ ...parametros, total_hasta: e.target.value })} 
                                                    ref={inputBusquedaRef} 
                                                    placeholder={'0'}
                                                    disabled={!paramsCheck.totales}
                                                    className="input-ui-data w-full disabled:bg-gray-500 disabled:text-gray-500 disabled:border-gray-400"
                                                    labelProps={{
                                                        className: "before:content-none after:content-none",
                                                    }}
                                                />
                                            </div>
                                        </div>   
                                    </div>
                                </div>                                
                            </div>
                        </Card>
                        <Card className="w-full px-6 py-3 mb-3 shadow-md">
                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-1">
                                {/* Primera columna */}
                                <div className="flex items-center gap-2 w-full">
                                    <div className="w-[220px]">
                                        <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                            Tipo de reporte:
                                        </Typography>
                                    </div>
                                    <div className="w-full">
                                        <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                            <SeleccionadorX newversion id='select-agrupacion' vector={reportes} valor={tipoReporte} noDefault onchange={(e)=>setTipoReporte(e.target.value)} claves={{id:'id',nombre:'nombre'}}/> 
                                        </div>   
                                    </div>
                                </div>
                                <div className="flex items-center gap-2 w-full egreso-new">
                                    <div className="w-[220px]">
                                        <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                            Balance:
                                        </Typography>
                                    </div>
                                    <div className="w-full">
                                        <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                            <SeleccionadorX newversion id='select-balance' vector={añosBalances} valor={parametros.id_balance_año_fiscal} noDefault onchange={(e)=>setParametros({...parametros,id_balance_año_fiscal:ConvertirValor(e.target.value)})} claves={{id:'id_año_fiscal',nombre:'nombre'}}/> 
                                        </div>   
                                    </div>
                                </div>                                
                            </div>


                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-1">
                                {/* Primera columna */}
                                 <div className="flex items-center gap-2 w-full">
                                    <div className="w-[220px]">
                                        <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                        Incluir vinculados
                                        </Typography>
                                    </div>
                                    <div className="w-full">
                                        <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                            <Switch
                                        ripple={false}
                                        name="sw-mesesdiezmados"
                                        checked={parametros.ministrosVinculados}
                                        onChange={(e) => setParametros({ ...parametros, ministrosVinculados: e.target.checked ? true : false })}
                                    />
                                        </div>   
                                    </div>
                                </div>                                   
                                <div className="flex items-center gap-2 w-full">
                                    <div className="w-[220px]">
                                        <Typography variant="h6" color="blue-gray" className="mt-1">
                                            Estado del balance:
                                        </Typography>
                                    </div>
                                     <div className="w-full">
                                        <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                            <SeleccionadorX newversion id='select-estado-balance' vector={estadosBalance} valor={parametros.id_estado_balance} nombre="Todos" onchange={(e)=>setParametros({...parametros,id_estado_balance:ConvertirValor(e.target.value)})} claves={{id:'id_estado_balance',nombre:'nombre'}}/> 
                                        </div>   
                                    </div>
                                </div>                                  
      
                            </div>

                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-1">
                                <div className="flex items-center gap-2 w-full">
                                    <div className="w-[220px]">
                                        <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                                    Columnas visibles
                                        </Typography>
                                    </div>
                                    <div className="w-full">
                                        <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                                <MuiSelect
                                                multiple
                                                displayEmpty
                                                value={columnasSeleccionadas}
                                                input={<OutlinedInput size="small" />}
                                                renderValue={(selected) => {
                                                    if (selected.length === 0) return 'Columnas a visualizar';
                                                    return (
                                                    <div className="flex flex-wrap gap-1">
                                                        {selected.map(val => {
                                                        const opt = columnas.find(o => o.campo === val);
                                                        return <Chip key={val} size="small" label={opt?.titulo || val} />;
                                                        })}
                                                    </div>
                                                    );
                                                }}
                                                sx={{ backgroundColor: '#fff', width: '100%' }}
                                                >
                                                {columnas.filter(i=>!i.obligatorio).map(col => (
                                                    <MenuItem
                                                    key={col.campo}
                                                    value={col.campo}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        const nuevasColumnas = columnas.map(c =>
                                                        c.campo === col.campo ? { ...c, incluir: !c.incluir } : c
                                                        );
                                                        setColumnas(nuevasColumnas);
                                                    }}
                                                    >
                                                    <Checkbox checked={col.incluir} />
                                                    <ListItemText primary={col.titulo} />
                                                    </MenuItem>
                                                ))}
                                                </MuiSelect>
                                        </div>   
                                    </div>
                                </div> 
                            </div>
                        </Card>
                    {!resultado?.length && <div className='flex justify-center'>
                        <Button variant="gradient" className="mt-4 w-48 flex justify-center" onClick={validarParametros} disabled={reporteEnEjecucion}>
                         {reporteEnEjecucion ? 
                             <Spinner className="h-4 w-4 mr-2" /> : 'Ejecutar'}   
                        </Button>
                    </div>}
            </div>
        </div>
}

function noNull(valor){
    if (valor){
        return valor
    }else{
        return '*'
    }
}

function convertirMesAñoAfechaDesde(fecha){
    
    // el propósito de esta conversión es recibir una fecha que fue tomada del datepicker en formato
    // mes/año y asegurar que la fecha desde es el primer día del mes y año seleccionados
    // también asegurarnos que se envía separado por guiones para que la fecha pueda viajar
    // sin errores en el request (no puedo mandar barras invertidas por ejemplo)

    const fecha_new = new Date(fecha)

    const mes = fecha_new.getMonth() + 1

   // const dia = fecha_new.getDate()

    const anio = fecha_new.getFullYear()
    

  // return `${mes < 10 ? `0${mes}` : mes}-01-${anio}`
   return `${anio}-${mes < 10 ? `0${mes}` : mes}-01`

}

export function convertirMesAñoAfechaCompleta(fecha) {
    // El propósito de esta conversión es recibir una fecha que fue tomada del datepicker en formato
    // mes/año y asegurar que la fecha se envía en el formato YYYY-MM-DD
    // también asegurarnos que se envía separado por guiones para que la fecha pueda viajar
    // sin errores en el request (no puedo mandar barras invertidas por ejemplo)

    const fecha_new = new Date(fecha);

    const dia = fecha_new.getDate();
    const mes = fecha_new.getMonth() + 1;
    const anio = fecha_new.getFullYear();

    return `${anio}-${mes < 10 ? `0${mes}` : mes}-${dia < 10 ? `0${dia}` : dia}`;
}

function convertirMesAñoAfechaHasta(fecha){
        
    // el propósito de esta conversión es recibir una fecha que fue tomada del datepicker en formato
    // mes/año y asegurar que la fecha hasta es el último día del mes y año seleccionados
    // también asegurarnos que se envía separado por guiones para que la fecha pueda viajar
    // sin errores en el request (no puedo mandar barras invertidas por ejemplo)

    const fecha_new = new Date(fecha)

    const mes = fecha_new.getMonth() + 1

    const dia = fecha_new.getDate()

    const anio = fecha_new.getFullYear()
    
   const nueva_fecha =  `${anio}-${mes < 10 ? `0${mes}` : mes}-${dia < 10 ? `0${dia}` : dia}`

    return obtenerFechaUltimoDiaMes(nueva_fecha,'YYYY-MM-DD','YYYY-MM-DD')
}

const reinicializarCriterios = (setParametros,parametros,nuevoCriterio)=>{


    setParametros({...parametros,
                      criterio : nuevoCriterio
                    })
}

const cargarNombreCriterio = (nuevoCriterio,nombreCriterio)=>{

    switch(nuevoCriterio){
        case 'añofiscal' : nombreCriterio.current = 'Seleccione el año fiscal:';return
        case 'mesaño' : nombreCriterio.current = 'Seleccione el mes y año:';return
        case 'periodo' : nombreCriterio.current = 'Seleccione el período:' ;return
        case 'año' : nombreCriterio.current = 'Seleccione el año:';return
        case 'fecha' : nombreCriterio.current = 'Seleccione la fecha:';return
    }
}

const ConvertirValor = (option_selected)=>{
    if(option_selected=='*'){
        return null
    }else{
        return option_selected
    }
}

const obtenerValueDeID = (id)=>{
    const element = document.getElementById(id)

    return element ? document.getElementById(id).value : '' 
 
}